module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d889a872f3b0985b28fa872764172ef1.svg";